var _path, _g, _circle, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowcaseSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 130,
    viewBox: "0 0 131 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.647 32.2788C35.5652 30.1129 37.2233 28.2759 39.3863 28.1362L83.6757 25.2751C85.9815 25.1261 87.9336 26.9561 87.9336 29.2667V92.6052C87.9336 94.8144 86.1427 96.6052 83.9336 96.6052H41.9284C39.778 96.6052 38.0124 94.9051 37.9313 92.7562L35.647 32.2788Z",
    fill: "#98A9FF",
    fillOpacity: 0.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10601_8814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.477 35.459C40.477 33.5812 41.9992 32.059 43.877 32.059H86.8569C88.7347 32.059 90.2569 33.5812 90.2569 35.459V38.4998V95.9677C90.2569 97.8454 88.7347 99.3677 86.8569 99.3677H43.877C41.9992 99.3677 40.477 97.8454 40.477 95.9677V38.4998V35.459Z",
    stroke: "#333333",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4876 35.614H61.4615C61.3164 35.614 61.1992 35.4077 61.1992 35.1522C61.1992 34.8967 61.3164 34.6904 61.4615 34.6904H71.4876C71.6327 34.6904 71.7498 34.8967 71.7498 35.1522C71.7498 35.4077 71.6327 35.614 71.4876 35.614Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.335 48.8262H50.8838V49.7341H64.335V48.8262Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.438 52.7964H50.8838V53.7044H60.438V52.7964Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7983 61.4766H50.8838V62.3845H59.7983V61.4766Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5939 74.9893H50.8838V75.8972H65.5939V74.9893Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5939 78.7622H50.8838V79.6702H65.5939V78.7622Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.335 88.1616H50.8838V89.0696H64.335V88.1616Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9747 65.4468H50.8838V66.3547H64.9747V65.4468Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4105 73.4302C76.2699 73.4302 76.1361 73.3644 76.0499 73.2509L73.6817 70.1343C73.5298 69.9345 73.5683 69.6508 73.7679 69.4987C73.9676 69.3466 74.2511 69.3852 74.4031 69.5849L76.406 72.2226L82.1798 65.0673C82.3295 64.8676 82.613 64.8244 82.8149 64.9743C83.0145 65.1241 83.0576 65.4101 82.9056 65.6098L76.7712 73.2463C76.685 73.3598 76.5512 73.4279 76.4105 73.4279V73.4302Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4105 88.1166C76.2699 88.1166 76.1361 88.0508 76.0499 87.9373L73.6817 84.8207C73.5298 84.6209 73.5683 84.3372 73.7679 84.1851C73.9676 84.033 74.2511 84.0716 74.4031 84.2714L76.406 86.909L81.5986 80.2026C81.7483 80.0028 82.0319 79.9597 82.2338 80.1095C82.4334 80.2593 82.4765 80.5453 82.3245 80.7451L76.7712 87.9328C76.685 88.0463 76.5512 88.1144 76.4105 88.1144V88.1166Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7466 49.7344C71.9514 49.7344 68.875 52.8108 68.875 56.606C68.875 60.4012 71.9514 63.4777 75.7466 63.4777C79.5419 63.4777 82.6183 60.4012 82.6183 56.606C82.6183 52.8108 79.5419 49.7344 75.7466 49.7344ZM75.746 52.828C75.9501 52.828 76.1353 52.9481 76.2177 53.1346L78.7946 58.9722C78.91 59.233 78.792 59.5372 78.5315 59.652C78.4642 59.6818 78.3936 59.6956 78.3242 59.6956C78.1263 59.6956 77.9373 59.581 77.8524 59.3882L77.3773 58.3125C77.3498 58.317 77.3216 58.3212 77.2928 58.3212H74.2005C74.1717 58.3212 74.1438 58.3173 74.116 58.3125L73.6409 59.3882C73.5264 59.6487 73.2215 59.7664 72.9617 59.6513C72.7013 59.5365 72.5829 59.2326 72.698 58.9722L75.2749 53.1346C75.3573 52.9481 75.5419 52.828 75.746 52.828ZM75.7466 54.6197L74.5676 57.2905H76.9257L75.7466 54.6197Z",
    fill: "#32BEB0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.415,
    y: 67.5078,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.415,
    y: 82.1943,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "#333333"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.4143,
    cy: 95.9143,
    r: 19.3143,
    fill: "#C1E498",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5684 97.4612L84.4005 102.001L93.2594 93.1416",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10601_8814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 69,
    fill: "white",
    transform: "translate(39.5 31)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowcaseSent);
export default __webpack_public_path__ + "static/media/showcase-sent.9ae632aa5d46ea7b477cfdd60495fec7.svg";
export { ForwardRef as ReactComponent };